export enum Device {
  Browser = 'browser',
  Server = 'server',
  Native = 'native',
}
